import { createStore, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";
import { rootReducer } from "./reducers";
import { composeWithDevTools } from 'redux-devtools-extension';
//? https://github.com/zalmoxisus/redux-devtools-extension

const middlewares = [thunkMiddleware];

console.log(`Env: ${process.env.NODE_ENV}`);
if (process.env.NODE_ENV !== `production`) {
  const { createLogger } = require(`redux-logger`);
  const logger = createLogger({
    collapsed: (getState, action, logEntry) => !logEntry.error,
    diff: true
  });

  middlewares.push(logger);
}
export const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(...middlewares)));
